import useFetchRefactored from 'civic-champs-shared/api/hooks/useFetchRefactored'
import { useCallback } from 'react'
import fileDownload from 'js-file-download'
import * as moment from 'moment'

import { DEFAULT_TIME_ZONE } from 'civic-champs-shared/utils/format'
import { useCurrentOrg } from 'auth/hooks'
import omitBy from 'lodash/omitBy'
import isUndefined from 'lodash/isUndefined'

const formatFileName = (name, organization, separator = '_') => {
  const today = moment()
    .tz(organization.timeZone || DEFAULT_TIME_ZONE)
    .format(`DDMMMYYYY${separator}HH:mm`)
  return `${name.replace(/\s/g, separator)}${separator}Responses${separator}${today}.csv`
}

export const useDownloadExportedQuestionnaire = () => {
  const organization = useCurrentOrg()
  const [request, status] = useFetchRefactored({
    successMessage: 'Export completed',
    errorMessage: 'Error exporting questionnaire',
  })

  const downloadExportedQuestionnaire = useCallback(
    ({ questionSetId, name }, { startDate, endDate }) => {
      return request({
        method: 'post',
        url: `/organizations/${organization.id}/question-set/${questionSetId}/export`,
        config: {
          responseType: 'blob',
          queryStringParameters: omitBy(
            {
              startDate,
              endDate,
            },
            isUndefined,
          ),
        },
      }).then(blob => fileDownload(blob, formatFileName(name, organization)))
    },
    [organization, request],
  )

  return [downloadExportedQuestionnaire, status]
}

export default useDownloadExportedQuestionnaire
